import dynamic from "next/dynamic";
import React, { FC } from "react";
import { IRebookingConfirmation } from "./IRebookingConfirmation";

const RebookingConfirmationModalBase = dynamic(
    () => import("./RebookingConfirmationModalBase")
);

const RebookingConfirmationModal: FC<IRebookingConfirmation.IProps> = props => {
    const { open } = props;

    if (!open) return null;

    return <RebookingConfirmationModalBase {...props} />;
};

export default RebookingConfirmationModal;
